import '@/assets/css'
import { createApp } from 'vue'
import i18n from './plugins/i18n'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import element from './plugins/element'
import directives from '@/directives'
import App from './App.vue'
import TableButton from './components/Table/install'
import './plugins/ali-arms'
import { globalBury } from './util/useBury'
import microApp from '@micro-zoe/micro-app'
import { getAuth } from './dev'

microApp.start({
  'router-mode': 'pure'
})

const init = () => {
  createApp(App)
    .use(i18n)
    .use(globalBury)
    .use(store)
    .use(router)
    .use(axios)
    .use(element)
    .use(directives)
    .use(TableButton)
    .mount('#app')

  // 首屏挂载完成后再预热 OEM 微应用，避免预加载任务参与首屏解析和执行。
  window.setTimeout(() => {
    microApp.preFetch([
      {
        name: 'my-app',
        url: process.env.NODE_ENV === 'development' ? 'http://localhost:3666/' : '/'
      }
    ], 3000)
  }, 5000)
}

if (process.env.NODE_ENV === 'development') {
  getAuth().then(init).catch(init)
} else {
  init()
}
// init()
